import Splide from "@splidejs/splide";
import "@splidejs/splide/dist/css/splide.min.css";

document.addEventListener("DOMContentLoaded", () => {
    const sliderEl = document.getElementById("tech-slider");
    if (!sliderEl) return;

    const splide = new Splide(sliderEl, {
        type: "loop",
        focus: "center",
        perPage: 1,
        arrows: false,
        pagination: false,
        autoplay: true,
        interval: 5000,
        speed: 600,
        padding: { left: "240px", right: "240px" },
        breakpoints: {
            1024: {
                padding: { left: "60px", right: "60px" },
            },
            640: {
                padding: { left: "20px", right: "20px" },
            },
        },
    });

    function setActiveFeature(index) {
        document.querySelectorAll(".feature-item").forEach((item, i) => {
            const title = item.querySelector("h3");
            const line = item.querySelector(".nav-line");

            const isActive = i === index;

            title.classList.toggle("text-[#0001AB]", isActive);
            title.classList.toggle("text-[#646464]", !isActive);

            if (line) {
                line.classList.toggle("w-[120px]", isActive);
                line.classList.toggle("w-0", !isActive);
            }
        });
    }

    splide.on("moved", (newIndex) => setActiveFeature(newIndex));
    splide.mount();

    setActiveFeature(0);
});
